import React from 'react';
import ChooseAccountsStep from 'components/AccountConnectionFlow/ChooseAccountsStep';

const ActivateGoogleAdsAccountsStep = (props) => {
  return <ChooseAccountsStep />;
};

export default ActivateGoogleAdsAccountsStep;
